import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface CartItemRequest {
  productId: number;
  formatKey: string;
  quantity: number;
}

export interface ValidatedProduct {
  id: number;
  productId: number;
  formatKey: string;
  formatName: string;
  name: string;
  price: number;
  imageUrl: string;
  active: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class CartValidationService {
  private validationUrl = `${environment.apiUrl}/cart/validate`;

  constructor(private http: HttpClient) { }

  validateCartItems(items: CartItemRequest[]): Observable<ValidatedProduct[]> {
    return this.http.post<ValidatedProduct[]>(this.validationUrl, items);
  }
}
